import { Component } from '@angular/core';


@Component({
  selector: 'app-waitlists',
  templateUrl: './waitlists.component.html',
  styleUrls: ['./waitlists.component.css']
})
export class WaitlistsComponent {

  constructor() {}

}
